// Imports (unchanged)
import { Wrapper } from "../../styles/AddBookStyle";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@mui/material';
import {
  ageGroupChoices,
  childGradeLvl,
  teenGradeLvl,
} from "../../../utils/Constants";
import {
  ageGroupSelected,
  gradeSelected,
  onAuthorEntered,
  onBookSelected,
  onParagraphChanged,
  onRequestToClearForm,
  onSaveParagraphsTriggered,
  onTitleEntered,
  onBookLevelSelected
} from "../../../slices/books/addBookSlice";
import { getEducationLvl } from "../../../utils/localStorage";
import { FormRow } from "../../../components";
import { FileUploader } from "react-drag-drop-files";
import AlertDialog from "../../../components/AlertDialog";
import errorHandler from "../../../utils/errorHandler";
import {
  getListOfBooksByAgeFromServer,
  requestToCreateNewBook,
  requestToUpdateBook
} from "../../../controller/addBook/crudBookController";
import { useLocation, useParams } from "react-router-dom";
import { getBookById } from "../../../controller/bookSelection/bookSelectionController";

const AddBooks = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [coverImage, setCoverImage] = useState(null);
  const [createNewForm, setCreateNewForm] = useState(false);
  const [updateBook, setUpdateBook] = useState(false);
  const [showReplaceWarning, setShowReplaceWarning] = useState(false);
  const [selectedUpdateBook, setSelectedUpdateBook] = useState(null);

  const {
    isLoading,
    ageGroupOpt,
    educationLevel,
    title,
    author,
    paragraph,
    paragraphs,
    bookList,
    level
  } = useSelector((store) => store.addBooks);
  const { selectedBook } = useSelector((store) => store.bookSelection);
  const dispatch = useDispatch();
  const { bookId } = useParams();
  const { state } = useLocation();
  const { ageGroup: passedAgeGroup } = state || {};

  const fileTypes = ["JPG", "PNG", "GIF"];

  useEffect(() => {
    if (bookId) dispatch(getBookById(bookId));
  }, [bookId, dispatch]);

  useEffect(() => {
    if (ageGroupOpt.name) {
      dispatch(getListOfBooksByAgeFromServer(ageGroupOpt));
    }
  }, [ageGroupOpt, dispatch]);

  useEffect(() => {
    if (passedAgeGroup) {
      dispatch(ageGroupSelected({ name: passedAgeGroup, isSelected: true }));
    }
  }, [passedAgeGroup, dispatch]);

  useEffect(() => {
    if (selectedBook?.title && selectedBook?.authors?.length > 0) {
      dispatch(onTitleEntered(selectedBook.title));
      dispatch(onAuthorEntered(selectedBook.authors[0].name));
      if (selectedBook.formats?.["image/jpeg"]) {
        setCoverImage(selectedBook.formats["image/jpeg"]);
      }
       if (selectedBook.paragraphText) {
        dispatch(onParagraphChanged(selectedBook.paragraphText.trim()));
      }
      if (!level) {
        dispatch(onBookLevelSelected('A'));
    }
    }
  }, [selectedBook, dispatch]);

  const onBookCoverAttached = (file) => setCoverImage(file);

  const onBookToUpdateSelected = (e) => {
    const selected = e.target.value;
    if (
      selectedBook?.title?.toLowerCase().trim() === selected.book?.title?.toLowerCase().trim() &&
      selectedBook?.authors?.[0]?.name?.toLowerCase().trim() === selected.book?.author?.toLowerCase().trim()
    ) {
      setSelectedUpdateBook(selected);
      setShowReplaceWarning(true);
    } else {
      dispatch(onBookSelected(selected));
    }
  };

  const confirmReplaceGutenBook = () => {
    dispatch(onBookSelected(selectedUpdateBook));
    setShowReplaceWarning(false);
    setSelectedUpdateBook(null);
  };

  const cancelReplaceGutenBook = () => {
    setShowReplaceWarning(false);
    setSelectedUpdateBook(null);
  };

  const onAgeGroupOptSelected = (e) => {
    const value = e.target.value;
    const obj = { name: value, isSelected: true };
    dispatch(getListOfBooksByAgeFromServer(obj));
    dispatch(ageGroupSelected(obj));
  };

  const onEducationLvlSelected = (e) => {
    const grade = e.target.value;
    const obj = { ageGroup: ageGroupOpt.name, grade };
    dispatch(gradeSelected(obj));
  };

  const onTitleChanged = (e) => dispatch(onTitleEntered(e.target.value));
  const onAuthorChanged = (e) => dispatch(onAuthorEntered(e.target.value));
  const onParagraphDataChannge = (e) => dispatch(onParagraphChanged(e.target.value));

  const onSaveParagraphs = (e) => {
    e.preventDefault();
    if (paragraph !== '') {
      dispatch(onSaveParagraphsTriggered({ paragraph: paragraph.replace(/\n/g, '') }));
    }
  };

  const onClearForm = (e) => {
    e.preventDefault();
    setOpenDialog(true);
  };

  const onCreateNewBook = (e) => {
    e.preventDefault();
    if (isFormValidated()) {
      setCreateNewForm(true);
      setOpenDialog(true);
    }
  };

  const onUpdateBook = (e) => {
    e.preventDefault();
    if (isFormValidated()) {
      setUpdateBook(true);
      setOpenDialog(true);
    }
  };

  const isFormValidated = () => {
    if (ageGroupOpt.name === 'Adult') {
      if (!title || !author || paragraphs.length === 0) {
        errorHandler("Required fields are missing!");
        return false;
      }
      return true;
    } else {
      if (!ageGroupOpt.name || !educationLevel || !title || !author || paragraphs.length === 0) {
        errorHandler("Required fields are missing!");
        return false;
      }
      return true
    }
  };

  const onCloseDialog = () => setOpenDialog(false);

  const runTaskAndCloseDialog = () => {
    const bookObj = getBookObj();
    const payload = {
      ageGroupOpt,
      bookObj
    };

    if (createNewForm) {
      dispatch(requestToCreateNewBook(payload));
    } else if (updateBook) {
      dispatch(requestToUpdateBook(payload));
    } else {
      dispatch(onRequestToClearForm());
    }
    onCloseDialog();
    setCreateNewForm(false);
    setUpdateBook(false);
  };

const getBookObj = () => {
  const splitParagraphs = (paragraphText) => {
  if (!paragraphText || paragraphText.trim().length < 1000) {
    return paragraphText.trim()
      ? [{ paragraph: paragraphText.trim() }]
      : [];
  }

  const cleaned = paragraphText.replace(/\s+/g, ' ').trim();
  const sentences = cleaned.match(/[^.!?]+[.!?]+["')\]]*\s*/g) || [];

  const result = [];
  let buffer = "";

  for (const sentence of sentences) {
    const temp = buffer + sentence;

    if (temp.trim().length < 1000) {
      buffer = temp;
    } else {
      if (buffer.trim().length > 0) {
        result.push({ paragraph: buffer.trim() });
      }
      buffer = sentence;
    }
  }

  if (buffer.trim().length > 0) {
    result.push({ paragraph: buffer.trim() });
  }

  return result;
};
  const cleanParagraphs =
    selectedBook?.paragraphText?.trim()?.length > 0
      ? splitParagraphs(selectedBook.paragraphText)
      : paragraphs.filter((p) => p.paragraph && p.paragraph.trim() !== '');

  return {
    grade: Number(educationLevel),
    book: {
      title,
      image: coverImage,
      author,
      level:level,
      paragraphs: cleanParagraphs
    }
  };
};
  const getGradeListBasedOnAge = () =>
    ageGroupOpt.name === "Child" ? childGradeLvl : teenGradeLvl;

  const renderUploaderOrImage = () => {
    if (coverImage && typeof coverImage === 'string') {
      return <img src={coverImage} alt="Book Cover" style={{ width: '180px', marginTop: '2rem', borderRadius: '8px' }} />
    }
    return (
      <div style={{ marginTop: "2rem" }}>
        <FileUploader
          label="Upload a picture of book cover"
          name="file"
          types={fileTypes}
          handleChange={onBookCoverAttached}
        />
      </div>
    );
  };

const getBookLevelView = () => (
  <div>
    <FormControl fullWidth>
      <InputLabel>Book Level</InputLabel>
      <Select
        value={level}
        onChange={(e) => dispatch(onBookLevelSelected(e.target.value))}
      >
        {['A', 'B', 'C', 'D','E'].map((lvl) => (
          <MenuItem key={lvl} value={lvl}>
            {lvl}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>
);


  return (
    <Wrapper>
      <form className="form">
        <h3>Add Books</h3>
        {ageGroupOpt.name && bookList.length > 0 && (
          <div className="update-book-select-style">
            <FormControl fullWidth>
              <Select
                displayEmpty
                value={bookList && bookList.book}
                input={<OutlinedInput />}
                onChange={onBookToUpdateSelected}
                renderValue={(selected) => !selected ? <Typography>Update Book</Typography> : selected.book.title}
              >
                <MenuItem disabled value="">
                  <p>Update Book</p>
                </MenuItem>
                {bookList && bookList.map((book) => (
                  <MenuItem key={book?._id} value={book}>{book.book.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}

        <div className="form-center">
          {ageGroupChoices.map(({ id, name }) => (
            <div key={id} className="group-opt-container">
              <RadioGroup value={ageGroupOpt.name} onChange={onAgeGroupOptSelected}>
                <FormControlLabel value={name} control={<Radio />} label={name} />
              </RadioGroup>
            </div>
          ))}

          {(ageGroupOpt.name === "Child" || ageGroupOpt.name === "Teen") && (
            <div>
              <FormControl fullWidth>
                <InputLabel>Grade</InputLabel>
                <Select
                  value={educationLevel || getEducationLvl(ageGroupOpt.name)}
                  onChange={onEducationLvlSelected}
                >
                  {getGradeListBasedOnAge().map((grade) => (
                    <MenuItem value={grade.grade} key={grade.grade}>{grade.grade}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
        </div>

        <div style={{ marginTop: "2rem" }}>
          {       
            getBookLevelView()
          }
      </div>

        <div className="sub-form-items">
          <FormRow type="text" name="Title" placeholder="Enter Title" required value={title} handleChange={onTitleChanged} />
          <FormRow type="text" name="Author" placeholder="Enter author's name" required value={author} handleChange={onAuthorChanged} />
        </div>

        {renderUploaderOrImage()}

        <div className="text-area-container">
          <button className="text-area-save-bt" onClick={onSaveParagraphs}>Save</button>
          <textarea
            className="text-area"
            placeholder="Enter paragraph here..."
            value={paragraph}
            onChange={onParagraphDataChannge}
          />
        </div>

        <div className="form-center" style={{ marginTop: "1rem" }}>
          <button className="btn btn-block" onClick={onClearForm} disabled={isLoading}>{isLoading ? "Please Wait" : "Clear"}</button>
          <button className="btn btn-block" onClick={onUpdateBook} disabled={isLoading}>{isLoading ? "Please Wait" : "Update"}</button>
          <button className="btn btn-block" onClick={onCreateNewBook} disabled={isLoading}>{isLoading ? "Please Wait" : "Create New"}</button>
        </div>
      </form>

      {showReplaceWarning && (
        <AlertDialog
          open={showReplaceWarning}
          onClose={cancelReplaceGutenBook}
          runTaskAndClose={confirmReplaceGutenBook}
          title="Replace Book?"
          description="This will replace the content fetched from Gutenberg with the selected book. Are you sure?"
          agreeText="Replace"
          disagreeText="Cancel"
        />
      )}

      {openDialog && (
        <AlertDialog
          open={openDialog}
          onClose={onCloseDialog}
          runTaskAndClose={runTaskAndCloseDialog}
          title={(createNewForm || updateBook) ? "Ready to submit?" : "Are you sure?"}
          description={(createNewForm || updateBook)
            ? "Request to save this book to server will be processed"
            : "All the progress will be deleted permanently from this machine."}
          agreeText={(createNewForm || updateBook) ? "Submit" : "Delete"}
          disagreeText={(createNewForm || updateBook) ? "Not Yet!" : "Cancel"}
        />
      )}
    </Wrapper>
  );
};

export default AddBooks;
